import React from 'react';

export const SkeletonCard = () => (
  <div className="bg-[#fafafa] border border-[#f0f0f0] rounded-xl overflow-hidden flex flex-col h-full animate-pulse">
    <div className="aspect-square bg-gray-200"></div>
    <div className="p-4 flex flex-col gap-2">
      <div className="h-3 w-12 bg-gray-200 rounded"></div>
      <div className="h-4 w-full bg-gray-200 rounded"></div>
      <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
      <div className="h-5 w-20 bg-gray-200 rounded mt-1"></div>
      <div className="h-10 w-full bg-gray-200 rounded mt-2"></div>
    </div>
  </div>
);

export const SkeletonText = ({ lines = 3 }) => (
  <div className="flex flex-col gap-2">
    {Array.from({ length: lines }).map((_, i) => (
      <div 
        key={i} 
        className="h-4 bg-gray-200 rounded" 
        style={{ width: `${100 - (i * 15)}%` }}
      ></div>
    ))}
  </div>
);

export const SkeletonDetail = () => (
  <div className="max-w-7xl mx-auto px-4 py-8 animate-pulse">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div>
        <div className="aspect-square bg-gray-200 rounded-2xl"></div>
        <div className="flex gap-2 mt-3">
          {[1,2,3,4].map(i => (
            <div key={i} className="w-14 h-14 bg-gray-200 rounded-xl"></div>
          ))}
        </div>
      </div>
      <div className="space-y-4">
        <div className="h-4 w-20 bg-gray-200 rounded"></div>
        <div className="h-8 w-full bg-gray-200 rounded"></div>
        <div className="h-4 w-32 bg-gray-200 rounded"></div>
        <div className="h-px bg-gray-200 my-4"></div>
        <div className="h-10 w-40 bg-gray-200 rounded"></div>
        <div className="flex gap-2 mt-4">
          <div className="h-12 flex-1 bg-gray-200 rounded-lg"></div>
          <div className="h-12 w-11 bg-gray-200 rounded-lg"></div>
        </div>
        <div className="h-12 w-full bg-gray-200 rounded-lg mt-2"></div>
      </div>
    </div>
  </div>
);